import React from 'react'
import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const TradingPairSummaryRowSkeleton = () => (
  <Root>
    <TitleUppercase>
      <Skeleton height={12} width={30} paddingBlock={1} />
      <Skeleton height={12} width={30} paddingBlock={1} />
    </TitleUppercase>
    <Value>
      <Skeleton height={20} width={60} paddingBlock={3} />
      <Skeleton height={20} width={60} paddingBlock={3} />
    </Value>
    <Ratio></Ratio>
  </Root>
)

const Root = styled.div`
  height: 50px;
`

const Title = styled.div`
  color: var(--text-9);

  font-size: 10px;
  font-weight: 600;
  line-height: 12px;

  display: flex;
  justify-content: space-between;
`

const TitleUppercase = styled(Title)`
  text-transform: uppercase;
`

const Value = styled.div`
  color: var(--text-12);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  display: flex;
  justify-content: space-between;
`

const Ratio = styled.div`
  background: #191919;
  display: flex;

  border-radius: 4px;
  height: 10px;
  gap: 2px;
  padding: 2px;
`
